import React, { useEffect, useState, useCallback, useRef } from "react";
import cn from "classnames";
import Master from "screen/Master";
import styles from "./AddSchedule.module.scss";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { getRequestInAssets as getRequest } from "services/axiosAssetsBaseClient";
import { getRequest as getEnterprise } from "services/axiosBaseClient";
import { postRequest, putRequest } from "services/axiosBaseClient";
import notificationService from "services/notification.service";
import { useHistory } from "react-router-dom";
// import "react-datetime-picker/dist/DateTimePicker.css";
import TextField from "@material-ui/core/TextField";
import Select from "react-select";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import { NotificationManager } from "react-notifications";

var id = undefined;
var action;
var view = undefined;
var readOnlyField = false;
var onlyView = false;
var updateView = false;
var selectedZoneName;
var selectedSiteName;

function AddScheduleView(props) {
  view = props?.match?.params?.view;
  id = props?.match?.params?.id;

  const intialFormValue = {
    zoneId: -1,
    zoneName: "",
    siteName: "",
    startDate: "",
    startHour: "",
    endHour: "",
    startMin: "",
    endMin: "",
    startTime: "",
    endDate: "",
    endTime: "",
    id: 0,
    name: "",
    days: "",
    siteId: -1,
  };

  const [formValues, setFormValues] = useState(intialFormValue);
  const [formErrors, setFormErrors] = useState("");
  const [title, setTitle] = useState("Schedule");
  const [siteList, setSiteList] = useState([]);
  const [zoneList, setZoneList] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loadder, setLoader] = useState(false);

  const history = useHistory();
  const startHourRef = useRef(null);
  const startMinRef = useRef(null);
  const endHourRef = useRef(null);
  const endMinRef = useRef(null);
  const weekDayArray = [
    { key: 1, value: "Monday" },
    { key: 2, value: "Tuesday" },
    { key: 3, value: "Wednesday" },
    { key: 4, value: "Thursday" },
    { key: 5, value: "Friday" },
    { key: 6, value: "Saturday" },
    { key: 0, value: "Sunday" },
  ];

  const todayDate = new Date();
  const currentDay = weekDayArray[todayDate.getDay() - 1]?.value;
  const [showStartHour, setShowStartHour] = useState(false);
  const [showEndHour, setShowEndHour] = useState(false);
  const [showStartMin, setShowStartMin] = useState(false);
  const [showEndMin, setShowEndMin] = useState(false);

  const toggleDropdown = (dropdownType) => {
    switch (dropdownType) {
      case "startHour":
        setShowStartHour(!showStartHour);
        setShowStartMin(false);
        setShowEndHour(false);
        setShowEndMin(false);
        break;
      case "startMin":
        setShowStartMin(!showStartMin);
        setShowStartHour(false);
        setShowEndHour(false);
        setShowEndMin(false);
        break;
      case "endHour":
        setShowEndHour(!showEndHour);
        setShowStartHour(false);
        setShowStartMin(false);
        setShowEndMin(false);
        break;
      case "endMin":
        setShowEndMin(!showEndMin);
        setShowEndHour(false);
        setShowStartHour(false);
        setShowStartMin(false);
        break;
      default:
        break;
    }
  };

  const getSite = useCallback(async (id) => {
    await getRequest(`bss/siteInfo?zoneId=` + id)
      .then((res) => {
        if (res?.data?.count >= 1) {
          setSiteList(res?.data?.sites);
        }
      })
      .catch((error) => {
        notificationService.showNonBlacklistedError(
          error?.config?.url,
          error?.response?.data?.message
        );
      });
  }, []);

  const getZones = useCallback(async (string) => {
    await getRequest("zone/getZoneInfo")
      .then((res) => {
        if (res.data != null) {
          setZoneList(res?.data?.zoneList);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getscheduleByID = async (id) => {
    await getEnterprise("getSchedule?scheduleId=" + id)
      .then((res) => {
        if (res.data != null) {
          patchForm(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  };

  useEffect(() => {
    getZones();
    if (id != undefined && view == undefined) {
      updateView = false;
      onlyView = false;
      setTitle("Update Schedule");
      action = "Update";
      getscheduleByID(id);
    } else {
      updateView = false;
      readOnlyField = false;
      onlyView = false;
      setTitle("Add Schedule");
      action = "Submit";
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e?.target;
    const numericValue = value.replace(/[^0-9]/g, "");
    setFormValues({ ...formValues, [name]: value });
    if (name === "zoneId") {
      zoneList.map((item) => {
        if (item?.zoneId == value) {
          selectedZoneName = item?.zone;
        }
      });
      getSite(value);
      setFormValues({
        ...formValues,
        ["zoneName"]: selectedZoneName,
        ["zoneId"]: value,
        ["siteId"]: -1,
        ["siteName"]: "",
      });
    }
    if (name === "startHour") {
      setFormValues({
        ...formValues,
        ["startHour"]: numericValue,
      });
    }
    if (name === "endHour") {
      setFormValues({
        ...formValues,
        ["endHour"]: numericValue,
      });
    }
    if (name === "startMin") {
      setFormValues({
        ...formValues,
        ["startMin"]: numericValue,
      });
    }
    if (name === "endMin") {
      setFormValues({
        ...formValues,
        ["endMin"]: numericValue,
      });
    }
    if (name === "startTime") {
      setFormValues({
        ...formValues,
        ["startTime"]: value,
      });
    }
    if (name === "endTime") {
      setFormValues({
        ...formValues,
        ["endTime"]: value,
      });
    }

    if (name === "siteId") {
      siteList.map((item) => {
        if (item?.siteId == value) {
          selectedSiteName = item?.siteName;
        }
      });
      setFormValues({
        ...formValues,
        ["siteId"]: value,
        ["siteName"]: selectedSiteName,
      });
    }
  };

  const patchForm = (data) => {
    if (data?.zoneId) {
      getSite(data?.zoneId);
    }
    if (data?.days) {
      getSelectedValue(data?.days);
    }
    selectedZoneName = data?.zoneName;
    selectedSiteName = data?.siteName;
    setFormValues({
      id: Number(data?.id),
      zoneName: data?.zoneName,
      zoneId: Number(data?.zoneId),
      siteId: Number(data?.siteId),
      endDate: dateReverse(data?.endDate),
      startDate: dateReverse(data?.startDate),
      siteName: data?.siteName,
      startTime: data?.startTime,
      endTime: data?.endTime,
      name: data?.name,
      days: data?.days,
      startHour: data?.startTime.split(":")[0],
      startMin: data?.startTime.split(":")[1],
      endHour: data?.endTime.split(":")[0],
      endMin: data?.endTime.split(":")[1],
    });
  };

  const handleSubmit = (e) => {
    console.log("submit function");
    e.preventDefault();
    let result = validate(formValues);
    if (Object.values(result).every((x) => x === "")) {
      const payload = {
        zoneId: formValues?.zoneId,
        zoneName: selectedZoneName,
        siteName: selectedSiteName,
        startDate: formValues?.startDate,
        // "endTime": formValues?.endTime,
        // "startTime": formValues?.startTime,
        endTime:
          formValues?.endDate +
          " " +
          (formValues?.endHour?.length < 2
            ? "0" + formValues?.endHour
            : formValues?.endHour) +
          ":" +
          (formValues?.endMin?.length < 2
            ? "0" + formValues?.endMin
            : formValues?.endMin) +
          ":00",
        startTime:
          formValues?.startDate +
          " " +
          (formValues?.startHour?.length < 2
            ? "0" + formValues?.startHour
            : formValues?.startHour) +
          ":" +
          (formValues?.startMin?.length < 2
            ? "0" + formValues?.startMin
            : formValues?.startMin) +
          ":00",
        endDate: formValues?.endDate,
        name: formValues?.name.trim(),
        days: formValues?.days,
        siteId: Number(formValues?.siteId),
        id: formValues?.id,
      };
      setLoader(true);
      if (action === "Update") {
        putRequest("updateSchedule", payload)
          .then((res) => {
            if (res.data.statusCode === 200 && res?.data) {
              routeChange();
              notificationService.showNonBlacklisted(
                res?.config?.url,
                res?.data.message
              );
              setLoader(false);
            }
            if (res.data.statusCode === 400 || res.statusCode === 208) {
              setLoader(false);
              NotificationManager.error(res?.data.message);
            }
          })
          .catch((error) => {
            notificationService.showNonBlacklistedError(
              error?.config?.url,
              error?.message
            );
          });
      } else if (action === "Submit") {
        try {
          postRequest("addSchedule", payload)
            .then((res) => {
              debugger;
              if (res.statusCode === 200 && res?.data) {
                history.push({
                  pathname: "/Schedule",
                });
                notificationService.showNonBlacklisted(
                  res?.config?.url,
                  res?.message
                );
                setLoader(false);
              }
              if (res.statusCode === 400 || res.statusCode === 208) {
                NotificationManager.error(res?.data.message);
                setLoader(false);
              }
            })
            .catch((error) => {
              setLoader(false);
              notificationService.showNonBlacklistedError(
                error?.config?.url,
                error.response.data.message
              );
            });
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  const getDaysOfWeekBetweenDates = (sDate, eDate) => {
    const startDate = moment(sDate);
    const endDate = moment(eDate);
    endDate.add(1, "day");
    const daysOfWeek = [];
    let i = 0;
    while (i < 7 && startDate < endDate) {
      daysOfWeek.push(startDate.day());
      startDate.add(1, "day");
      i++;
    }
    return daysOfWeek;
  };

  const dateValidation = (
    startDate,
    endDate,
    startDateTime,
    endDateTime,
    startTime,
    endTime
  ) => {
    const s = new Date(startDate);
    const e = new Date(endDate);
    const sDateTime = new Date(startDateTime);
    const eDateTime = new Date(endDateTime);
    const today = new Date();
    const scheduleStartTime = toDate(startTime, "h:m");
    const scheduleEndTime = toDate(endTime, "h:m");
    if (selected.some((d) => d?.value === currentDay)) {
      if (s > e) {
        return true;
      } else if (sDateTime < today || eDateTime < today) {
        return true;
      } else if (sDateTime.getTime() >= eDateTime.getTime()) {
        return true;
      } else if (scheduleStartTime >= scheduleEndTime) {
        return true;
      }
    } else {
      if (s > e) {
        return true;
      } else if (sDateTime.getTime() >= eDateTime.getTime()) {
        return true;
      } else if (scheduleStartTime >= scheduleEndTime) {
        return true;
      }
    }
  };

  function toDate(dStr, format) {
    var now = new Date();
    if (format == "h:m") {
      now.setHours(dStr?.substr(0, dStr.indexOf(":")));
      now.setMinutes(dStr?.substr(dStr.indexOf(":") + 1));
      now.setSeconds(0);
      return now;
    } else return "Invalid Format";
  }

  const validate = (formValues) => {
    const errors = {};

    if (!formValues.zoneId || formValues.zoneId == -1) {
      errors.zoneName = "Zone is required!";
    } else {
      errors.zoneName = "";
    }

    if (!formValues.name) {
      errors.name = "Schedule is required!";
    } else if (!/^[a-zA-Z0-9_ ]*$/i.test(formValues.name)) {
      errors.name = "This is not a valid Schedule Name";
    } else {
      errors.name = "";
    }

    if (!formValues.siteId || formValues.siteId == -1) {
      errors.siteName = "Site Name is required!";
    } else {
      errors.siteName = "";
    }

    if (formValues?.startDate !== "" && formValues?.endDate !== "") {
      var checkDate = dateValidation(
        formValues?.startDate,
        formValues?.endDate,
        formValues?.startDate +
          " " +
          (formValues?.startHour?.length < 2
            ? "0" + formValues?.startHour
            : formValues?.startHour) +
          ":" +
          (formValues?.startMin?.length < 2
            ? "0" + formValues?.startMin
            : formValues?.startMin) +
          ":00",
        formValues?.endDate +
          " " +
          (formValues?.endHour?.length < 2
            ? "0" + formValues?.endHour
            : formValues?.endHour) +
          ":" +
          (formValues?.endMin?.length < 2
            ? "0" + formValues?.endMin
            : formValues?.endMin) +
          ":00",
        formValues?.startHour + ":" + formValues?.startMin,
        formValues?.endHour + ":" + formValues?.endMin
      );
      if (checkDate) {
        notificationService.showNonBlacklistedError("", "Invalid Date or Time");
        errors.checkDate = "error in date/time";
      } else {
        errors.checkDate = "";
      }
    }

    if (!formValues.startDate) {
      errors.startDate = "Start Date is required!";
    } else {
      errors.startDate = "";
    }
    if (!formValues.endDate) {
      errors.endDate = "End Date is required!";
    } else {
      errors.endDate = "";
    }
    if (!formValues.startHour) {
      errors.startHour = "Start Time is required!";
    } else {
      errors.startHour = "";
    }
    if (!formValues.startMin) {
      errors.startMin = "Start Time is required!";
    } else {
      errors.startMin = "";
    }
    if (!formValues.endHour) {
      errors.endHour = "End Time is required!";
    } else {
      errors.endHour = "";
    }
    if (!formValues.endMin) {
      errors.endMin = "End Time is required!";
    } else {
      errors.endMin = "";
    }

    if (selected?.length < 1) {
      errors.selected = "Day is required!";
    } else {
      errors.selected = "";
    }

    setFormErrors(errors);
    return errors;
  };

  const onStartHourKey = (e) => {
    var numLen = e?.target?.value?.length;
    var val = parseInt(e?.target?.value);
    if (val < 0 || val > 23) {
      startHourRef.current.value = "";
    } else if (numLen > 2) {
      startHourRef.current.value = "";
    }
  };

  const onStartMinKey = (e) => {
    var numLen = e?.target?.value?.length;
    var val = parseInt(e?.target?.value);
    if (val < 0 || val > 59) {
      startMinRef.current.value = "";
    } else if (numLen > 2) {
      startMinRef.current.value = "";
    }
  };

  const onEndHourKey = (e) => {
    var numLen = e?.target?.value?.length;
    var val = parseInt(e?.target?.value);
    if (val < 0 || val > 23) {
      endHourRef.current.value = "";
    } else if (numLen > 2) {
      endHourRef.current.value = "";
    }
  };

  const onEndMinKey = (e) => {
    var numLen = e?.target?.value?.length;
    var val = parseInt(e?.target?.value);
    if (val < 0 || val > 59) {
      endMinRef.current.value = "";
    } else if (numLen > 2) {
      endMinRef.current.value = "";
    }
  };

  var weekdays = [];
  selected.map((item) => {
    weekdays.push(item?.label);
  });

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  const handlestartDateChange = (e) => {
    setSelected([]);
    if (e) {
      var dtstr = convert(e);
      setFormValues({ ...formValues, startDate: dtstr });
    } else {
      setFormValues({ ...formValues, startDate: "" });
    }
  };

  const handleDateChange = (e) => {
    setSelected([]);
    if (e) {
      var dtstr = convert(e);
      setFormValues({ ...formValues, endDate: dtstr });
    } else {
      setFormValues({ ...formValues, endDate: "" });
    }
  };

  const options = [
    // { label: "Sunday", value: "Sunday" },
    // { label: "Monday", value: "Monday" },
    // { label: "Tuesday", value: "Tuesday" },
    // { label: "Wednesday", value: "Wednesday" },
    // { label: "Thursday", value: "Thursday" },
    // { label: "Friday", value: "Friday" },
    // { label: "Saturday", value: "Saturday", disabled: true },
  ];

  const handleMultiSelectChange = (e) => {
    var weekdays = [];
    selected.map((item) => {
      weekdays.push(item?.label);
    });
    var datastr = weekdays.toString();
    setFormValues({ ...formValues, ["days"]: datastr });
  };

  useEffect(() => {
    handleMultiSelectChange();
  }, [selected]);

  if (formValues?.startDate !== "" && formValues?.endDate !== "") {
    const weekArray = getDaysOfWeekBetweenDates(
      formValues?.startDate,
      formValues?.endDate
    );
    let op = weekArray.map((e, i) => {
      let temp = weekDayArray.find((element) => element.key === e);
      if (temp.value) {
        e = temp.value;
      }
      return e;
    });
    op.map((item) => {
      options.push({ label: item, value: item });
    });
  }

  const getSelectedValue = (value) => {
    const array = value.split(",");
    array.map((item) => {
      selected.push({
        label: capitalizeFirstLetter(item),
        value: capitalizeFirstLetter(item),
      });
    });
  };

  function capitalizeFirstLetter(str) {
    // converting first letter to uppercase
    const capitalized = str.charAt(0).toUpperCase() + str.slice(1);
    return capitalized;
  }

  const removeDuplicateDays = (e) => {
    setSelected(e);
  };

  function dateReverse(str) {
    return str?.split("-").reverse().join("-");
  }

  const routeChange = () => {
    history.push({
      pathname: "/Schedule",
      state: { compomentRenderType: "view" },
    });
  };
  return (
    <>
      <div id="AddSchedule_block" className={cn(styles.flex_item1)}>
        <div id="AddSchedule_layout" className={cn(styles.flex1)}>
          <h2
            id="AddSchedule_Heading"
            className={cn(styles.medium_title, styles.medium_title_layout)}
          >
            {"Schedule"}
          </h2>

          <div
            id="AddSchedule_From"
            className={cn(styles.group, styles.group_layout)}
          >
            <form>
              <div
                id="AddSchedule_From_Block"
                className={cn(styles.flex3, styles.flex3_layout)}
              >
                <h3
                  id="AddSchedule_From_title"
                  className={cn(styles.subtitle, styles.subtitle_layout)}
                >
                  {title}
                </h3>
                <hr className={cn(styles.line, styles.line_layout)} />
                <div
                  id="AddSchedule_From_row1"
                  className={cn(styles.flex2, styles.flex2_layout)}
                >
                  <div
                    id="AddSchedule_From_SelectZone"
                    className={cn(styles.flex2_item)}
                  >
                    <div
                      id="AddSchedule_SelectZone_block"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="AddSchedule_SelectZone_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Select Zone*"}
                      </div>
                      <select
                        name="zoneId"
                        className={cn(
                          styles.line1,
                          styles.line1_layout,
                          styles.style_select
                        )}
                        value={formValues?.zoneId}
                        onChange={handleChange}
                        disabled={readOnlyField}
                      >
                        <option value="-1">Select Zone</option>
                        {zoneList.map((obj) => {
                          return <option value={obj.zoneId}>{obj.zone}</option>;
                        })}
                      </select>
                      <p>{formErrors?.zoneName}</p>
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div
                    id="AddSchedule_From_SelectSite"
                    className={cn(styles.flex2_item)}
                  >
                    <div
                      id="AddSchedule_SelectSite_block"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="AddSchedule_SelectSite_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Select Site*"}
                      </div>
                      <select
                        name="siteId"
                        className={cn(
                          styles.line1,
                          styles.line1_layout,
                          styles.style_select
                        )}
                        value={formValues?.siteId}
                        onChange={handleChange}
                        disabled={readOnlyField}
                      >
                        <option value="-1">Select site</option>
                        {siteList?.map((val) => {
                          return (
                            <option value={val?.siteId}>{val?.siteName}</option>
                          );
                        })}
                      </select>
                      <p>{formErrors?.siteName}</p>
                    </div>
                  </div>
                </div>
                <div
                  id="AddSchedule_From_row2"
                  className={cn(styles.flex2, styles.flex2_layout)}
                >
                  <div
                    id="AddSchedule_From_Schedule"
                    className={cn(styles.flex2_item)}
                  >
                    <div
                      id="AddSchedule_Schedule_block"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="AddSchedule_Schedule_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Schedule*"}
                      </div>
                      <input
                        id="AddSchedule_Schedule_input"
                        name="name"
                        maxLength="50"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues?.name}
                        disabled={readOnlyField}
                        onChange={handleChange}
                      />
                    </div>
                    <p>{formErrors?.name}</p>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div
                    id="AddSchedule_Form_startDate"
                    className={cn(styles.flex2_item)}
                  >
                    <div
                      id="AddSchedule_startDate_block"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="AddSchedule_startDate_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Start Date*"}
                      </div>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          name="startDate"
                          views={["year", "month", "day"]}
                          inputFormat="DD-MM-YYYY"
                          value={formValues.startDate}
                          onChange={handlestartDateChange}
                          renderInput={(params) => <TextField {...params} />}
                          disablePast
                        />
                      </LocalizationProvider>
                    </div>
                    <p>{formErrors?.startDate}</p>
                  </div>
                </div>
                <div
                  id="AddSchedule_From_row3"
                  className={cn(styles.flex2, styles.flex2_layout)}
                >
                  <div
                    id="AddSchedule_Form_endDate"
                    className={cn(styles.flex2_item)}
                  >
                    <div
                      id="AddSchedule_endDate_block"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="AddSchedule_endDate_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"End Date*"}
                      </div>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          name="endDate"
                          views={["year", "month", "day"]}
                          inputFormat="DD-MM-YYYY"
                          value={formValues.endDate}
                          onChange={handleDateChange}
                          renderInput={(params) => <TextField {...params} />}
                          disablePast
                        />
                      </LocalizationProvider>
                    </div>
                    <p>{formErrors?.endDate}</p>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div
                    id="AddSchedule_Form_startTime"
                    className={cn(styles.flex2_item)}
                  >
                    <div
                      id="AddSchedule_startTime_block"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="AddSchedule_startTime_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Start Time*"}
                      </div>
                      <div
                        id="AddSchedule_startHour"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div style={{ position: "relative" }}>
                          <input
                            id="AddSchedule_startHour_input"
                            type="tel"
                            placeholder="HH"
                            name="startHour"
                            onKeyUp={onStartHourKey}
                            ref={startHourRef}
                            className={cn(styles.line1, styles.line1_layout)}
                            value={formValues?.startHour}
                            disabled={readOnlyField}
                            onChange={handleChange}
                          />
                          <img
                            id="AddSchedule_startHour_img"
                            style={{
                              position: "absolute",
                              right: "0",
                              cursor: "pointer",
                            }}
                            src={require("assets/clock.svg").default}
                            onClick={() => toggleDropdown("startHour")}
                          />
                          {showStartHour && (
                            <div
                              id="AddSchedule_startHour_Dropdown"
                              className={cn(styles.HourDropdown)}
                            >
                              {Array.from({ length: 24 }, (_, index) => (
                                <div
                                  key={index}
                                  style={{ cursor: "pointer", padding: "5px" }}
                                  onClick={() => {
                                    handleChange({
                                      target: {
                                        name: "startHour",
                                        value: String(index + 1).padStart(
                                          2,
                                          "0"
                                        ), // Pad with leading zero if needed
                                      },
                                    });
                                    toggleDropdown("startHour");
                                  }}
                                >
                                  {String(index + 1).padStart(2, "0")}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                        <div>
                          <input
                            id="AddSchedule_startMin"
                            type="tel"
                            placeholder="MM"
                            name="startMin"
                            onKeyUp={onStartMinKey}
                            ref={startMinRef}
                            className={cn(styles.line1, styles.line1_layout)}
                            value={formValues?.startMin}
                            disabled={readOnlyField}
                            onChange={handleChange}
                          />
                          <img
                            id="AddSchedule_startMin_img"
                            style={{
                              position: "absolute",
                              right: "0",
                              cursor: "pointer",
                            }}
                            src={require("assets/clock.svg").default}
                            onClick={() => toggleDropdown("startMin")}
                          />
                          {showStartMin && (
                            <div
                              id="AddSchedule_startMin_Dropdown"
                              className={cn(styles.MinDropdown)}
                            >
                              {Array.from({ length: 60 }, (_, index) => (
                                <div
                                  key={index}
                                  style={{ cursor: "pointer", padding: "5px" }}
                                  onClick={() => {
                                    handleChange({
                                      target: {
                                        name: "startMin",
                                        value: String(index).padStart(2, "0"),
                                      },
                                    });
                                    toggleDropdown("startMin");
                                  }}
                                >
                                  {String(index).padStart(2, "0")}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <p>{formErrors?.startHour || formErrors?.startMin}</p>
                  </div>
                </div>
                <div
                  id="AddSchedule_From_row4"
                  className={cn(styles.flex2, styles.flex2_layout)}
                >
                  <div
                    id="AddSchedule_Form_endTime"
                    className={cn(styles.flex2_item)}
                  >
                    <div
                      id="AddSchedule_endTime_block"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="AddSchedule_endTime_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"End Time*"}
                      </div>
                      <div
                        id="AddSchedule_endHour"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div style={{ position: "relative" }}>
                          <input
                            id="AddSchedule_endHour_input"
                            name="endHour"
                            placeholder="HH"
                            type="tel"
                            onKeyUp={onEndHourKey}
                            ref={endHourRef}
                            className={cn(styles.line1, styles.line1_layout)}
                            value={formValues?.endHour}
                            disabled={readOnlyField}
                            onChange={handleChange}
                          />
                          <img
                            id="AddSchedule_endHour_img"
                            style={{
                              position: "absolute",
                              right: "0",
                              cursor: "pointer",
                            }}
                            src={require("assets/clock.svg").default}
                            onClick={() => toggleDropdown("endHour")}
                          />
                          {showEndHour && (
                            <div
                              id="AddSchedule_endHour_Dropdown"
                              className={cn(styles.HourDropdown)}
                            >
                              {Array.from({ length: 24 }, (_, index) => (
                                <div
                                  key={index}
                                  style={{ cursor: "pointer", padding: "5px" }}
                                  onClick={() => {
                                    handleChange({
                                      target: {
                                        name: "endHour",
                                        value: String(index + 1).padStart(
                                          2,
                                          "0"
                                        ), // Pad with leading zero if needed
                                      },
                                    });
                                    toggleDropdown("endHour");
                                  }}
                                >
                                  {String(index + 1).padStart(2, "0")}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                        <div>
                          <input
                            id="AddSchedule_endMin_input"
                            name="endMin"
                            placeholder="MM"
                            type="tel"
                            onKeyUp={onEndMinKey}
                            ref={endMinRef}
                            className={cn(styles.line1, styles.line1_layout)}
                            value={formValues?.endMin}
                            disabled={readOnlyField}
                            onChange={handleChange}
                          />
                          <img
                            id="AddSchedule_endMin_img"
                            style={{
                              position: "absolute",
                              right: "0",
                              cursor: "pointer",
                            }}
                            src={require("assets/clock.svg").default}
                            onClick={() => toggleDropdown("endMin")}
                          />
                          {showEndMin && (
                            <div
                              id="AddSchedule_endMin_Dropdown"
                              className={cn(styles.MinDropdown)}
                            >
                              {Array.from({ length: 60 }, (_, index) => (
                                <div
                                  key={index}
                                  style={{ cursor: "pointer", padding: "5px" }}
                                  onClick={() => {
                                    handleChange({
                                      target: {
                                        name: "endMin",
                                        value: String(index).padStart(2, "0"),
                                      },
                                    });
                                    toggleDropdown("endMin");
                                  }}
                                >
                                  {String(index).padStart(2, "0")}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <p>{formErrors?.endHour || formErrors?.endMin}</p>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div
                    id="AddSchedule_SelectDays_block"
                    className={cn(styles.flex2_item)}
                  >
                    <div
                      id="AddSchedule_SelectDays"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="AddSchedule_SelectDays_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Select Days*"}
                      </div>
                      <Select
                        options={options}
                        placeholder="Select"
                        value={selected}
                        onChange={(e) => {
                          // setSelected(e)
                          removeDuplicateDays(e);
                        }}
                        // setSelected
                        isSearchable={true}
                        isMulti
                        isCheckbox
                        isDisabled={onlyView}
                      />
                    </div>
                    <p>{formErrors?.selected}</p>
                  </div>
                </div>
              </div>
            </form>
            {/* <div className={cn(styles.flex2, styles.flex2_layout)}></div> */}
            <div
              id="AddSchedule_Button_view"
              className={
                !updateView
                  ? cn(styles.flex9, styles.flex9_layout_2)
                  : cn(styles.flex9, styles.flex9_layout_3)
              }
            >
              <div className={cn(styles.flex9_item)} onClick={routeChange}>
                {/* <Link to="/Schedule"
                state={{
                  compomentRenderType: "view"
                }}
                > */}
                <div
                  id="AddSchedule_cancelButton"
                  className={cn(styles.block7, styles.block7_layout)}
                  style={{ cursor: "pointer" }}
                >
                  <h5
                    id="AddSchedule_cancelButton_title"
                    className={cn(
                      styles.highlights1,
                      styles.highlights1_layout
                    )}
                  >
                    {"Cancel"}
                  </h5>
                </div>
                {/* </Link> */}
              </div>
              <div className={cn(styles.flex9_spacer)} />
              {!updateView ? (
                <div className={cn(styles.flex9_item)}>
                  <div
                    id="AddSchedule_submitButton"
                    // onClick={() => {loadder ? null : handleSubmit()}}
                    onClick={loadder ? null : handleSubmit}
                    className={cn(styles.block8, styles.block8_layout)}
                    style={{ cursor: "pointer" }}
                  >
                    <h5
                      id="AddSchedule_submitButton_title"
                      className={cn(
                        styles.highlights2,
                        styles.highlights2_layout
                      )}
                    >
                      {action}
                    </h5>
                    {/* <button>{action}</button> */}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default function AddSchedule(props) {
  return (
    <>
      <Master opts={props} screen={AddScheduleView} showStatus={false} />
    </>
  );
}

AddSchedule.inStorybook = true;
